import React from "react";
import { Link } from "react-router-dom";
import "./NotFoundPage.scss";
import SorryNotFound from "../../assets/icons/SorryNotFound";

const NotFoundPage = () => {
  return (
    <div className="container">
      <div
        className="col-sm-8 col-xl-4 container border rounded-2 p-4
            shadow p-3 mb-5 not-found"
      >
        <h1>404 - Not Found!</h1>
        <SorryNotFound className="mt-2" width={88} height={88} fill="#5c157d" />
        <Link className="link" to="/">
          <h5 className="mt-3">Go home</h5>
        </Link>
      </div>
    </div>
  );
};
export default NotFoundPage;
